import React, { createContext, useContext } from 'react'
import usePhoneManagement from './usePhoneManagement'

export type PhoneManagementContextValue = ReturnType<typeof usePhoneManagement>

const PhoneManagementContext =
  createContext<PhoneManagementContextValue | null>(null)

export function PhoneManagementProvider({
  children,
}: {
  children: React.ReactNode
}): React.ReactElement {
  const value = usePhoneManagement()
  return (
    <PhoneManagementContext.Provider value={value}>
      <div className="scp-phone-management-container">{children}</div>
    </PhoneManagementContext.Provider>
  )
}

export function usePhoneManagementCtx(): PhoneManagementContextValue {
  const ctx = useContext(PhoneManagementContext)
  if (!ctx) {
    throw new Error(
      'usePhoneManagementCtx must be used within PhoneManagementProvider',
    )
  }
  return ctx
}
